import { Routes } from '@angular/router';
import { PaymentHomeComponent } from './payment/components/payment-home/payment-home.component';
import { PaymentProcessedComponent } from './payment/components/payment-processed/payment-processed.component';
import { ErrorComponent } from './core/components/error/error.component';
import { PayComponent } from './payment/components/pay/pay.component';
import { PaymentStatusComponent } from './payment/components/payment-status-component.component';
import { NotFoundComponent } from './core/components/not-found/not-found.component';

export const routes: Routes = [
  { path: 'error', component: ErrorComponent },
  { path: '404', component: NotFoundComponent },
  {
    path: ':publicId',
    component: PaymentHomeComponent,
    children: [
      { path: 'status', component: PaymentStatusComponent },
      { path: ':transactionCorrelationId/processed/:paymentStatus', component: PaymentProcessedComponent },
      { path: '', pathMatch: 'full', component: PayComponent }
    ]
  },
  { path: '**', component: NotFoundComponent }
];
